





















import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { TypeDisplay, TypeHeading } from '@bambeehr/pollen';
import FAQAccordion from './ui/FAQAccordion.vue';

interface IProps {
  question: string;
  answer: string;
}

export default defineComponent({
  name: 'BaseFAQ',
  components: {
    TypeHeading,
    FAQAccordion,
    TypeDisplay,
  },
  props: {
    FAQItems: {
      type: Array as PropType<Array<IProps>>,
      required: false,
    },
    title: {
      type: String,
      default: 'Frequently Asked Questions',
    },
  },
});
